<template>
  <div>
    <el-button class="newAdd" @click="openDialog">修改返佣比例</el-button>
    <el-dialog
      title="修改返佣比例"
      :visible.sync="moveDialogVisible"
      width="40%"
      center
      @close="clear"
    >
      <el-form :model="form" :rules="rules" ref="form">
        <el-form-item label="UID" :label-width="formLabelWidth" prop="userId">
          <div class="search">
            <el-input
              v-model="form.userId"
              class="searchIpt"
              autocomplete="off"
            ></el-input>
          </div>
        </el-form-item>

        <el-form-item
          label="合约返佣比例"
          :label-width="formLabelWidth"
          prop="rate"
        >
          <el-input
            v-model="form.rate"
            class="searchIpt"
            autocomplete="off"
            maxlength="3"
            @input="handleIntegerInput('rate')"
          >
            <template slot="append">%</template></el-input
          >
        </el-form-item>
        <el-form-item
          label="现货返佣比例"
          :label-width="formLabelWidth"
          prop="spotRate"
        >
          <el-input
            v-model="form.spotRate"
            class="searchIpt"
            autocomplete="off"
            maxlength="3"
            @input="handleIntegerInput('spotRate')"
          >
            <template slot="append">%</template>
          </el-input>
        </el-form-item>
        <!-- <el-form-item label="otc返佣比例" :label-width="formLabelWidth" prop="otcRate" >
        <el-input v-model="form.otcRate" class="searchIpt" autocomplete="off">
          <template slot="append">%</template></el-input>
    </el-form-item> -->
      </el-form>
      <!-- <span slot="footer" class="dialog-footer">
            <el-button size="small" type="primary" @click="handleRate">添加</el-button>
            <el-button size="small"  @click="clear">重置</el-button>
          </span> -->
      <span slot="footer" class="dialog-footer">
        <el-button @click="clear">取 消</el-button>
        <el-button type="primary" @click="handleRate">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { integerRateRule, sanitizeIntegerInput } from '../../validate'

export default {
  data() {
    return {
      moveDialogVisible: false,
      form: {
        rate: '',
        userId: '',
        spotRate: '',
      },
      formLabelWidth: '140px',
      rules: {
        userId: [{ required: true, message: '请输入UID', trigger: 'blur' }],
        rate: [integerRateRule(true)],
        spotRate: [integerRateRule(false)],
      },
    }
  },
  methods: {
    ...mapActions('partnerList', ['upgradeRate']),
    handleIntegerInput(field) {
      this.form[field] = sanitizeIntegerInput(this.form[field])
    },
    openDialog() {
      this.moveDialogVisible = true
    },
    handleRate() {
      this.$refs['form'].validate((valid) => {
        if (!valid) {
          return false
        }
        const params = { ...this.form }
        if (params.spotRate === '' || params.spotRate === null || params.spotRate === undefined) {
          delete params.spotRate
        } else {
          params.spotRate = Number(params.spotRate)
        }
        this.upgradeRate(params).then((res) => {
          if (res.code == 0) {
            if (res.data.code == 0) {
              this.$message.success('修改成功')
              this.$emit('refresh')
              this.clear()
            } else {
              this.$message.error(res.data.msg || '修改失败')
              this.clear()
            }
          } else {
            this.$message.error('修改失败')
            this.clear()
          }
        })
      })
    },
    clearFiled() {
      this.$refs['form'].resetFields()
    },
    clear() {
      this.moveDialogVisible = false
      this.$refs['form'].resetFields()
    },
  },
}
</script>

<style lang="less" src="../../../../styles/button.less" scoped>
.content {
  // border: 1px solid #f5f6f7;
  padding: 20px;
  width: 100%;
  height: 200px;
  .up {
    border: 1px solid #f5f6f7;
    width: 100%;
    height: 50%;
    display: flex;
  }
  .down {
    border: 1px solid #f5f6f7;
    width: 100%;
    height: 50%;
    display: flex;
    justify-content: space-around;
    align-items: center;
  }
  .item {
    border-right: 1px solid #f5f6f7;
    display: flex;
    width: 50%;
    height: 100%;
    justify-content: center;
    align-items: center;
    .ipt {
      width: 90%;
    }
  }
}
.btn1 {
  display: flex;
  justify-content: center;
  width: 300px;
  margin: 0 auto;
}
</style>
